import React from 'react';

import CardsSkeleton from 'components/skeletons/CardsSkeleton';
import { useQueryGetCountries } from 'Customers/hooks/useCustomers';

import NewCustomerBasicInfoInputs from './NewCustomerBasicInfoInputs';
import NewCustomerBillingAddressInfoInputs from './NewCustomerBillingAddressInfoInputs';
import InputsSectionContainer from '../InputsSectionContainer/InputsSectionContainer';

const NewCustomerBasicInfo = (formik) => {
  const { isLoading, data } = useQueryGetCountries();
  return (
    <section className='w-100'>
      <h4 className='subtitle font-size-20 mt-7 mb-5'>Now, some basic information about the company</h4>
      {isLoading && <CardsSkeleton col={12} height={350} num={1} />}
      {!isLoading && (
        <>
          <InputsSectionContainer
            title='Basic Info'
            subTitle='Define some basic details about the company'
            className='mb-3'
          >
            <NewCustomerBasicInfoInputs formik={formik} countries={data?.data?.items} />
          </InputsSectionContainer>
          <InputsSectionContainer
            title='Billing Address Info'
            subTitle={
              formik.values.accountType === 'LIVE_INSTANCE'
                ? 'Define fields that will accommodate the companies tax requirements'
                : 'Optional for demo and test sites. A provided zip code must match the selected country'
            }
            className='mb-3'
          >
            <NewCustomerBillingAddressInfoInputs formik={formik} accountType={formik.values.accountType} />
          </InputsSectionContainer>
        </>
      )}
    </section>
  );
};
export default NewCustomerBasicInfo;
